import usePagination from "@/hooks/usePagination";
import { useMemo } from "react";
import useGetCreditIssuanceListForRegistry from "./useGetCreditIssuanceListForRegistry";

export const useGetCreditIssuanceListForRegistryPagination = () => {
	const pagination = usePagination();
	const creditIssuanceList = useGetCreditIssuanceListForRegistry(pagination.limit, pagination.offset);
	return useMemo(
		() => ({
			creditIssuanceList,
			pagination,
		}),
		[creditIssuanceList, pagination],
	);
};
